import { render } from "./DispatchAdditionals.vue?vue&type=template&id=10813b90"
import script from "./DispatchAdditionals.vue?vue&type=script&lang=js"
export * from "./DispatchAdditionals.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DispatchAdditionals.vue?vue&type=style&index=0&id=10813b90&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/driver/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__